import * as $ from "jquery";
import "slick-carousel";
import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import * as _ from "underscore";
import {on, Options} from "../utils/decorators";


@Options({
    template: false,
    el: ".js-circle-grid-w-tabs-slider-1-wrap",
    ui: {
        sliderMain: ".js-slider-main",
    }
})
export default class ViewController extends Marionette.View<Backbone.Model>{
    constructor() {
        super();
    }

    // --------------------------------
    // Events
    // --------------------------------

    // stub


    // --------------------------------
    // Functions
    // --------------------------------

    onRender() {
        // Temp
        console.log("circle grid w/tabs slider 1 rendered");
        this.initSlider();
    }

    initSlider() {

        // NOTE: set `centerMode: true` IF you want to
        // center and see edges of off-screen cards

        this.ui.sliderMain.slick({
            infinite: true,
            arrows: true,
            dots: true,
            slidesToShow: 1,
            slidesToScroll: 1
        });
    }
}



// WEBPACK FOOTER //
// ./django/project/@static/@modules/circle-grid-w-tabs-1-slider/controller.ts